export default function dispatchPageNoScroll(className = 'no-scroll') {
  document.querySelectorAll('html, body').forEach((element) => {
    element.classList.add(className)
  })
}
